/**
 * Wave section — textPath startOffset scrubbed to scroll (GSAP + ScrollTrigger).
 * Depends on assets/cu-window.js (theme.liquid).
 */
(function () {
  function loadScrollTrigger() {
    if (window.CU && typeof window.CU.loadScrollTrigger === 'function') {
      return window.CU.loadScrollTrigger();
    }
    return Promise.reject(new Error('CU Wave: cu-window.js not loaded.'));
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function initCuWave(root) {
    if (!root || root.dataset.cuWaveReady === 'true') {
      return;
    }

    if (prefersReducedMotion()) {
      root.dataset.cuWaveReady = 'true';
      return;
    }

    var textPath = root.querySelector('.wave_text');
    if (!textPath) {
      return;
    }

    var section = root.closest('.section_wave');

    loadScrollTrigger()
      .then(function (gsap) {
        if (!root.isConnected || !textPath.isConnected) {
          return;
        }

        if (root._cuWaveCtx) {
          root._cuWaveCtx.revert();
          root._cuWaveCtx = null;
        }

        gsap.config({ nullTargetWarn: false });

        var ctxScope = section || root;
        var ctx = gsap.context(function () {
          gsap.to(textPath, {
            attr: { startOffset: '-90%' },
            scrollTrigger: {
              trigger: section || root,
              scrub: 1,
              markers: false,
            },
          });
        }, ctxScope);

        root._cuWaveCtx = ctx;
        root.dataset.cuWaveReady = 'true';
      })
      .catch(function () {
        /* GSAP / ScrollTrigger failed — leave text static */
      });
  }

  function destroyCuWave(root) {
    if (!root) {
      return;
    }
    if (root._cuWaveCtx) {
      root._cuWaveCtx.revert();
      root._cuWaveCtx = null;
    }
    delete root.dataset.cuWaveReady;
  }

  function scanAndInit(container) {
    var scope = container || document;
    var nodes = scope.querySelectorAll('[data-cu-wave-root]');
    for (var i = 0; i < nodes.length; i++) {
      initCuWave(nodes[i]);
    }
  }

  function registerGlobalListenersOnce() {
    if (window.__cuWaveListeners) {
      return;
    }
    window.__cuWaveListeners = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scanAndInit();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      scanAndInit(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var roots = event.target.querySelectorAll('[data-cu-wave-root]');
      for (var i = 0; i < roots.length; i++) {
        destroyCuWave(roots[i]);
      }
    });
  }

  registerGlobalListenersOnce();
  scanAndInit();
})();
